import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _reviewConfig from '@/views/review/components/review-config/index.vue';
export default {
  name: 'StartReview',
  props: {
    subjectCode: {
      type: Number,
      default: 0
    },
    totalData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      startDisabled: true
    };
  },
  watch: {
    'totalData.totalCardCount': {
      immediate: true,
      deep: true,
      handler: function handler(value) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.startDisabled = !value;

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  },
  methods: {
    // 开始复习
    startReview: function startReview() {
      this.startDisabled = true;
      window.open(this.totalData.startReviewUrl, '_self'); // window.open('https://${location.host}/tcscreen/monday/answer/review?pageType=4&taskId=32326', '_self')
    },
    // 复习设置
    reviewConfig: function reviewConfig() {
      this.$showModal(_reviewConfig, {
        subjectCode: this.subjectCode
      }, {
        title: '复习设置',
        noFooter: true,
        width: '560px',
        showClose: false
      });
    }
  }
};